<div class="maintainance-info">
  <h3>Bald können Sie wieder Ihre Versicherungsprämie berechnen.</h3>
  <p>Wir arbeiten gerade daran, dass der Online-Rechner weiterhin zuverlässig und schnell funktioniert. In wenigen Stunden werden Ihnen alle Rechner wie gewohnt zur Verfügung stehen.</p>
  <p>Vielen Dank für Ihr Verständnis.</p>
</div>
